import Utils from "../../services/Utils.js";

export function getLiveTemplate(game, market_type) {
  if (!game.odd) {
    return "";
  }
  //   console.log(JSON.stringify(game.sport_id));

  return `<div class="singleOrderIdHolder singleGameContent" data-game-value="${
    game.sport_id
  }" id="${game.id}">
                 <a class="singleTeamNames" href="#/livematch/${
                   game.id
                 }?sportId=${game.sport_id}" data-id="${game.id}">
                     <div class="singleDateColumn">
                         ${
                           game.sport_id != 5
                             ? `<span id="${game.id}-timer">${game.current_minute}</span>`
                             : `<span id="${game.id}">-</span>`
                         }
                        <span class="numberofmarkets">${
                          game.count_options
                        } ></span>
                        ${
                          game.stream_id
                            ? `
                          <span class="livestream-option">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-monitor"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line></svg>         
                          </span>
                        `
                            : ""
                        }
                     </div>
                     <div class="singleDetailsColumn">
                       <div class="singleTeamRowLabel">
                         <span class="singleHomeName">${game.home_team}</span>
                         <span class="gameSingleHomeScore"></span>
                       </div>
                       <div class="singleTeamRowLabel">
                         <span class="singleAwayName">${game.away_team}</span>
                         <span class="gameSingleAwayScore"></span>
                       </div>
                     </div>

                    ${
                      [2, 5, 20].includes(game.sport_id)
                        ? `
                      <div class="singleMatchMultipleResult">
                        ${parseResultList(
                          game.result,
                          game.result_list,
                          true,
                          game.sport_id
                        )}
                      </div>
                      `
                        : `
                      <div class="singleMatchResult">
                        <span>${
                          game.result.split("-") &&
                          game.result.split("-").length > 0
                            ? game.result.split("-")[0]
                            : ""
                        }</span>
                        <span>${
                          game.result.split("-") &&
                          game.result.split("-").length > 1
                            ? game.result.split("-")[1]
                            : ""
                        }</span>
                      </div>
                      `
                    }
                 </a>


                 <div class="singleHomeOdd bettingBtn   ${
                   Math.floor(
                     (parseFloat(game.odd.split(",")[0].split("|")[1]) +
                       Number.EPSILON) *
                       100
                   ) /
                     100 ==
                   1
                     ? "disabledBtn"
                     : ""
                 }  ${
    game.odd.split(",").length > 0
      ? game.odd.split(",")[0].split("|")[0]
      : "disabledBtn"
  } ${game.odd.split(",")[0].split("|")[0]}-coef" match-odd="${(
    Math.floor(
      (parseFloat(game.odd.split(",")[0].split("|")[1]) + Number.EPSILON) * 100
    ) / 100
  ).toFixed(2)}" match-home-name="${game.home_team}" match-away-name="${
    game.away_team
  }" match-market="${Utils.getMatchMarket(game.odd.split(",")[0])}" coef-id="${
    game.odd.split(",")[0].split("|")[0]
  }" bet-id="${
    game.odd.split(",")[0].split("|")[0]
  }"  match-market-option="${Utils.getMatchMarketOption(
    game.odd.split(",")[0]
  )}" match-is-live="1" game-id="${game.id}">
  ${
    market_type == 3 && game.odd.split(",")[0].split("|").length > 2
      ? `<span class="marketTypeDescription">${
          game.odd.split(",")[0].split("|")[2].split(" ")[1]
        }</span>`
      : ``
  }
  ${(
    Math.floor(
      (parseFloat(game.odd.split(",")[0].split("|")[1]) + Number.EPSILON) * 100
    ) / 100
  ).toFixed(2)}</div>


                 <div class="singleDrawOdd bettingBtn  ${
                   game.odd.split(",").length > 1 &&
                   Math.floor(
                     (parseFloat(game.odd.split(",")[1].split("|")[1]) +
                       Number.EPSILON) *
                       100
                   ) /
                     100 ==
                     1
                     ? "disabledBtn"
                     : ""
                 }  ${
    game.odd.split(",").length > 1
      ? game.odd.split(",")[1].split("|")[0]
      : "disabledBtn"
  } ${
    game.odd.split(",").length > 1
      ? game.odd.split(",")[1].split("|")[0]
      : "1.00"
  }-coef"  match-is-live="1" match-odd="${
    game.odd.split(",").length > 1
      ? (
          Math.floor(
            (parseFloat(game.odd.split(",")[1].split("|")[1]) +
              Number.EPSILON) *
              100
          ) / 100
        ).toFixed(2)
      : ""
  }" match-home-name="${game.home_team}" match-away-name="${
    game.away_team
  }"  match-market="${Utils.getMatchMarket(
    game.odd.split(",")[0]
  )}" match-market-option="${Utils.getMatchMarketOption(
    game.odd.split(",")[1]
  )}" coef-id="${
    game.odd.split(",").length > 1 ? game.odd.split(",")[1].split("|")[0] : ""
  }" bet-id="${
    game.odd.split(",").length > 1 ? game.odd.split(",")[1].split("|")[0] : ""
  }" game-id="${game.id}">
  ${
    market_type == 3 && game.odd.split(",")[0].split("|").length > 2
      ? `<span class="marketTypeDescription">${
          game.odd.split(",")[0].split("|")[2].split(" ")[1]
        }</span>`
      : ``
  }
  ${
    game.odd.split(",").length > 1
      ? (
          Math.floor(
            (parseFloat(game.odd.split(",")[1].split("|")[1]) +
              Number.EPSILON) *
              100
          ) / 100
        ).toFixed(2)
      : ""
  }</div>


                 <div class="singleAwayOdd bettingBtn  ${
                   game.odd.split(",").length > 2 &&
                   Math.floor(
                     (parseFloat(game.odd.split(",")[2].split("|")[1]) +
                       Number.EPSILON) *
                       100
                   ) /
                     100 ==
                     1
                     ? "disabledBtn"
                     : ""
                 } ${
    game.odd.split(",").length > 2
      ? game.odd.split(",")[2].split("|")[0]
      : "disabledBtn"
  }  ${
    Math.floor(
      (parseFloat(game.odd.split(",")[0].split("|")[1]) + Number.EPSILON) * 100
    ) /
      100 ==
    1
      ? "disabledBtn"
      : ""
  } ${
    game.odd.split(",").length > 2
      ? game.odd.split(",")[2].split("|")[0]
      : "1.00"
  }-coef"  match-is-live="1" match-odd="${
    game.odd.split(",").length > 2
      ? (
          Math.floor(
            (parseFloat(game.odd.split(",")[2].split("|")[1]) +
              Number.EPSILON) *
              100
          ) / 100
        ).toFixed(2)
      : "0.00"
  }" match-home-name="${game.home_team}" match-away-name="${
    game.away_team
  }" match-market="${Utils.getMatchMarket(
    game.odd.split(",")[0]
  )}" match-market-option="${Utils.getMatchMarketOption(
    game.odd.split(",").pop()
  )}" coef-id="${
    game.odd.split(",").length > 2 ? game.odd.split(",")[2].split("|")[0] : ""
  }" bet-id="${
    game.odd.split(",").length > 2 ? game.odd.split(",")[2].split("|")[0] : ""
  }" game-id="${game.id}">${
    game.odd.split(",").length > 2
      ? (
          Math.floor(
            (parseFloat(game.odd.split(",")[2].split("|")[1]) +
              Number.EPSILON) *
              100
          ) / 100
        ).toFixed(2)
      : ""
  }</div>
               </div>`;
}

export function getLiveTemplateEvent(game) {
  if (!game.result) return "";

  return `<div class="singleGameContent singleOrderIdHolder" data-game-value="${
    game.sport_id
  }" id="${game.id}">
           <a class="singleTeamNames" href="#/livematch/${game.id}" data-id="${
    game.id
  }">
               <div class="singleDateColumn">
                  <span id='${game.id}-timer'>${game.current_minute}</span>
              <span class="numberofmarkets">${game.count_options} ></span>
               </div>
               <div class="singleDetailsColumn">
                 <div class="singleTeamRowLabel">
                   <span class="singleHomeName">${game.home_team}</span>
                   <span class="gameSingleHomeScore"></span>
                 </div>
                 <div class="singleTeamRowLabel">
                   <span class="singleAwayName">${game.away_team}</span>
                   <span class="gameSingleAwayScore"></span>
                 </div>
            
               </div>
               ${
                 [2, 5, 20].includes(game.sport_id)
                   ? `
                <div class="singleMatchMultipleResult">
                  ${parseResultList(
                    game.result,
                    game.result_list,
                    true,
                    game.sport_id
                  )}
                </div>
                `
                   : `
                <div class="singleMatchResult">
                  <span>${
                    game.result.split("-") && game.result.split("-").length > 0
                      ? game.result.split("-")[0]
                      : ""
                  }</span>
                  <span>${
                    game.result.split("-") && game.result.split("-").length > 1
                      ? game.result.split("-")[1]
                      : ""
                  }</span>
                </div>
                `
               }
           </a>
           <div class="singleHomeOdd bettingBtn   ${
             Math.floor(
               (parseFloat(game.odd.split(",")[0].split("|")[1]) +
                 Number.EPSILON) *
                 100
             ) /
               100 ==
             1
               ? "disabledBtn"
               : ""
           }  ${
    game.odd.split(",").length > 0
      ? game.odd.split(",")[0].split("|")[0]
      : "disabledBtn"
  } ${game.odd.split(",")[0].split("|")[0]}-coef" match-odd="${(
    Math.floor(
      (parseFloat(game.odd.split(",")[0].split("|")[1]) + Number.EPSILON) * 100
    ) / 100
  ).toFixed(2)}" match-home-name="${game.home_team}" match-away-name="${
    game.away_team
  }" match-market="${game.odd.split(",")[0].split("|")[2]}" coef-id="${
    game.odd.split(",")[0].split("|")[0]
  }" bet-id="${game.odd.split(",")[0].split("|")[0]}" game-id="${game.id}">${(
    Math.floor(
      (parseFloat(game.odd.split(",")[0].split("|")[1]) + Number.EPSILON) * 100
    ) / 100
  ).toFixed(2)}</div>


           <div class="singleDrawOdd bettingBtn  ${
             game.odd.split(",").length > 1 &&
             Math.floor(
               (parseFloat(game.odd.split(",")[1].split("|")[1]) +
                 Number.EPSILON) *
                 100
             ) /
               100 ==
               1
               ? "disabledBtn"
               : ""
           }  ${
    game.odd.split(",").length > 1
      ? game.odd.split(",")[1].split("|")[0]
      : "disabledBtn"
  } ${
    game.odd.split(",").length > 1
      ? game.odd.split(",")[1].split("|")[0]
      : "1.00"
  }-coef" match-odd="${
    game.odd.split(",").length > 1
      ? (
          Math.floor(
            (parseFloat(game.odd.split(",")[1].split("|")[1]) +
              Number.EPSILON) *
              100
          ) / 100
        ).toFixed(2)
      : ""
  }" match-home-name="${game.home_team}" match-away-name="${
    game.away_team
  }" match-market="${
    game.odd.split(",").length > 1 ? game.odd.split(",")[1].split("|")[2] : ""
  }" coef-id="${
    game.odd.split(",").length > 1 ? game.odd.split(",")[1].split("|")[0] : ""
  }" bet-id="${
    game.odd.split(",").length > 1 ? game.odd.split(",")[1].split("|")[0] : ""
  }" game-id="${game.id}">
${
  game.odd.split(",").length > 1
    ? (
        Math.floor(
          (parseFloat(game.odd.split(",")[1].split("|")[1]) + Number.EPSILON) *
            100
        ) / 100
      ).toFixed(2)
    : ""
}</div>


           <div class="singleAwayOdd bettingBtn  ${
             game.odd.split(",").length > 2 &&
             Math.floor(
               (parseFloat(game.odd.split(",")[2].split("|")[1]) +
                 Number.EPSILON) *
                 100
             ) /
               100 ==
               1
               ? "disabledBtn"
               : ""
           } ${
    game.odd.split(",").length > 2
      ? game.odd.split(",")[2].split("|")[0]
      : "disabledBtn"
  }  ${
    Math.floor(
      (parseFloat(game.odd.split(",")[0].split("|")[1]) + Number.EPSILON) * 100
    ) /
      100 ==
    1
      ? "disabledBtn"
      : ""
  } ${
    game.odd.split(",").length > 2
      ? game.odd.split(",")[2].split("|")[0]
      : "1.00"
  }-coef" match-odd="${
    game.odd.split(",").length > 2
      ? (
          Math.floor(
            (parseFloat(game.odd.split(",")[2].split("|")[1]) +
              Number.EPSILON) *
              100
          ) / 100
        ).toFixed(2)
      : "0.00"
  }" match-home-name="${game.home_team}" match-away-name="${
    game.away_team
  }" match-market="${
    game.odd.split(",").length > 2 ? game.odd.split(",")[2].split("|")[2] : ""
  }" coef-id="${
    game.odd.split(",").length > 2 ? game.odd.split(",")[2].split("|")[0] : ""
  }" bet-id="${
    game.odd.split(",").length > 2 ? game.odd.split(",")[2].split("|")[0] : ""
  }" game-id="${game.id}">${
    game.odd.split(",").length > 2
      ? (
          Math.floor(
            (parseFloat(game.odd.split(",")[2].split("|")[1]) +
              Number.EPSILON) *
              100
          ) / 100
        ).toFixed(2)
      : ""
  }</div>
         </div>`;
}

export function parseResultList(mainResult, resultList, isOverview, sport_id) {
  let view = "";
  if (!resultList) return view;

  const returnResult = resultList
    .split(";")
    .map((item) => {
      const itemResult = item.split(",");
      if (itemResult.length >= 3) {
        return {
          type: itemResult[0],
          result:
            sport_id === "20"
              ? itemResult.at(-1).split("-")
              : itemResult[1].split(":"),
          set: parseInt(itemResult[2]),
        };
      }
      return view;
    })
    .filter((i) => i !== null)
    .sort(({ set: a }, { set: b }) => a - b);

  if (mainResult) {
    const item = mainResult.split("-");
    view += `<div><div>${item[0] ?? ""}</div><div>${item[1] ?? ""}</div></div>`;
  } else {
    view += `<div><div></div><div></div></div>`;
  }

  if (returnResult.some((r) => r.type === "1")) {
    const items = returnResult.filter((r) => r.type === "1");
    if (isOverview && sport_id === 5) {
      // show last set only for tennis in overview
      const item = items.pop();
      view += `<div><div>${item.result[0] ?? 0}</div><div>${
        item.result[1] ?? 0
      }</div></div>`;
    } else if (!isOverview) {
      items.forEach((item) => {
        view += `<div><div>${item.result[0] ?? 0}</div><div>${
          item.result[1] ?? 0
        }</div></div>`;
      });
    }
  }

  // if (isOverview && returnResult.some(r => r.type === '5')) {
  //   const items = returnResult.filter(r => r.type === '5');
  //   items.forEach(item => {
  //     view += `<div><div>${item.result[0] ?? 0}</div><div>${item.result[1] ?? 0}</div></div>`;
  //   });
  // }

  if (
    (isOverview || sport_id === "20") &&
    returnResult.some((r) => r.type === "4")
  ) {
    const items = returnResult.filter((r) => r.type === "4");
    items.forEach((item) => {
      view += `<div><div>${item.result[0] ?? 0}</div><div>${
        item.result[1] ?? 0
      }</div></div>`;
    });
  }

  return view;
}
